
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 12h24M4 17h24M25.818 25H6.182C4.976 25 4 24.155 4 23.111V9.89C4 8.845 4.976 8 6.182 8h19.636C27.024 8 28 8.845 28 9.889V23.11C28 24.155 27.024 25 25.818 25zM8.222 21.444h5.556M22.666 21.444h1.112","stroke":"#121131","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    